import type { FC } from 'react'
import { Sidebar } from '../sidebar'
import * as styles from './styles'
import { LayoutWithSidebarProps } from './types'

export const LayoutWithSidebar: FC<
  React.PropsWithChildren<LayoutWithSidebarProps>
> = ({ children, headline, theme = 'light' }) => (
  <div css={styles.container}>
    <div css={styles.content({ theme })}>
      <Sidebar headline={headline} theme={theme} />
      {children}
    </div>
  </div>
)
LayoutWithSidebar.displayName = 'Ex Astra: LayoutWithSidebar'
